import React from 'react'

import { AwardMark } from '../../../components/AwardMark'
import { Card } from '../../../components/Card'
import { ImageProps } from '../../../components/Image'
import { Truncate } from '../../../components/Truncate'
import { Facility as FacilityIcon, Online as OnlineIcon } from '../../../icons'
import { MapFacilityCardProps } from '../types'
import { useImageMapper } from '../utils/useImageMapper'

export const MapFacilityCard = (props: MapFacilityCardProps) => {
  const {
    idGroup = 'facility_',
    id,
    href,
    as,
    external,
    target,
    imageMapper,
    isOnline,
    isFavorited,
    isFavoriteLoading,
    onFavoriteClick,
    name,
    station,
    activities,
    reviewCount,
    reviewScore,
    priority,
    maxWidth = 366,
    awardYear,
  } = props
  const images = useImageMapper(props, imageMapper)
  const icon = !isOnline ? <FacilityIcon gradient /> : <OnlineIcon gradient />
  const handleFavoriteClick = React.useCallback(() => {
    onFavoriteClick?.(id)
  }, [id, onFavoriteClick])

  const facilityLink = {
    href,
    as,
    external,
    target,
  }

  return (
    <Card
      id={`${idGroup}${id}`}
      variant="primary"
      layout="horizontal"
      raised
      maxWidth={maxWidth}
    >
      <Card.Image
        images={[images[0] as ImageProps]}
        {...facilityLink}
        priority={priority}
      />
      <Card.Content>
        {awardYear !== undefined && (
          <AwardMark year={awardYear} className="mb-1" />
        )}
        <Card.Content.Heading
          icon={icon}
          {...facilityLink}
          isFavorited={isFavorited}
          isFavoriteLoading={isFavoriteLoading}
          onFavoriteClick={onFavoriteClick ? handleFavoriteClick : undefined}
        >
          {name}
        </Card.Content.Heading>
        <Card.Content.Body mt={1}>
          <Truncate>
            {activities
              .map((a) => (typeof a === 'string' ? a : a.name))
              .join(' / ')}
          </Truncate>
        </Card.Content.Body>
        <Card.Content.Review
          mt={1}
          score={reviewScore}
          count={reviewCount}
          rightContent={<Truncate>{station}</Truncate>}
        />
      </Card.Content>
    </Card>
  )
}
